import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

const ContractAnnex = () => {
  const { contractId, annexId } = useParams();
  const [fileUrl, setFileUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [fileType, setFileType] = useState("");

  const checkFileAndSetType = async (url) => {
    try {
      setLoading(true);
      
      // Intentar acceder al archivo para verificar que existe
      const response = await fetch(url, { method: 'HEAD' });
      
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        setFileType(contentType || '');
        setFileUrl(url);
        setError("");
      } else {
        setError("Archivo no encontrado");
      }
    } catch (err) {
      setError("Error al cargar el archivo");
    } finally {
      setLoading(false);
    }
  };

  const renderFilePreview = () => {
    if (loading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
          <Typography variant="body1" sx={{ ml: 2 }}>
            Cargando archivo...
          </Typography>
        </Box>
      );
    }

    if (error) {
      return (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      );
    }

    // Determinar el tipo de archivo y renderizar la previsualización apropiada
    if (fileType.includes('pdf')) {
      return (
        <Box sx={{ width: '100%', height: '80vh' }}>
          <iframe
            src={fileUrl}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title={`Anexo ${annexId}`}
          />
        </Box>
      );
    } else if (fileType.includes('image')) {
      return (
        <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
          <img
            src={fileUrl}
            alt={`Anexo ${annexId}`}
            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </Box>
      );
    } else if (fileType.includes('text') || fileType.includes('json')) {
      return (
        <Box sx={{ mt: 2 }}>
          <iframe
            src={fileUrl}
            width="100%"
            height="400px"
            style={{ border: '1px solid #ccc' }}
            title={`Anexo ${annexId}`}
          />
        </Box>
      );
    } else {
      // Para otros tipos de archivo, mostrar un enlace de descarga
      return (
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="body1" gutterBottom>
            Vista previa no disponible para este tipo de archivo
          </Typography>
          <a
            href={fileUrl}
            download={`anexo_${annexId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Typography variant="button" color="primary">
              Descargar archivo
            </Typography>
          </a>
        </Box>
      );
    }
  };

  useEffect(() => {
    if (contractId && annexId) {
      const url = `https://storage.googleapis.com/royal_contracts_tdea/${contractId}/annexe_${annexId}`;
      checkFileAndSetType(url);
    }
  }, [contractId, annexId]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Anexo del Contrato {contractId}
      </Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Anexo ID: {annexId}
      </Typography>
      
      {renderFilePreview()}
    </Box>
  );
};

export default ContractAnnex;
